import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import "./experienceCard.css";

const ExperienceCard = ({ cardTitle, details }) => {
  return (
    <div
      className="experience-card"
      data-aos="fade-right"
      data-aos-duration="1500"
    >
      <h3>{cardTitle}</h3>
      <div className="experience_content">
        {details.map((experience) => {
          return (
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                <h4>{experience.title}</h4>
                {experience.level === "@Education" && (
                  <small className="text-light">
                    <a href="https://www.education.gov.tn" target="_blank" rel="noreferrer">
                      {experience.level}
                    </a>
                  </small>
                )}
                {experience.level === "@TVTC" && (
                  <small className="text-light">
                    <a
                      href="https://tvtc.gov.sa/ar/Pages/default.aspx"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {experience.level}
                    </a>
                  </small>
                )}
                {experience.level !== "@Education" &&
                  experience.level !== "@TVTC" && (
                    <small className="text-light">{experience.level}</small>
                  )}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default ExperienceCard;
